import { baseConfig } from '../baseConfig';

/**
 * Get image URL from image key.
 * @function getTransformationUrl
 * @param {string} imageKey - imageKey.
 * @param {string} location - location.
 * @param {string} browser - browser.
 * @param {number} version - version.
 * @return {string} image URL.
 */

// thumbnail desktop v2 -- for productboxes
// just the imagekey -- works for the rest (full size)

export const getTransformationUrl = (
    imageKey = 'default',
    location: 'pdp' | 'cart' | 'thumbnail' = 'pdp',
    browser: 'desktop' | 'mobile' = 'desktop',
    version: 1 | 2 = 1,
): string => {
    const transformationType = `${browser}-${location}-v${version}`;
    return `${baseConfig.urls.productImageBase}/t_${transformationType}/${imageKey}.jpg`;
};

// Handles the improved versions of the images pointing to the correct CDN
export type TImageSize = '40' | '80' | '120' | '200' | '240' | '320' | '400' | '800' | 'original';

export const getTransformationUrlV2 = (imageKey = 'default', imageSize: TImageSize = '800'): string => {
    const transform = imageSize === 'original' ? `tr:n-${imageSize}` : `tr:n-t_${imageSize}`;
    return `${baseConfig.urls.productImageBase}/${transform}/${imageKey}.jpg`;
};
